import { PropsWithChildren, useEffect, useState } from 'react'
import { Trans } from 'react-i18next'
import {
  ActivityIndicator,
  NativeSyntheticEvent,
  Platform,
  Pressable,
  PressableProps,
  StyleProp,
  StyleSheet,
  TargetedEvent,
  View,
  ViewStyle,
} from 'react-native'
import { Color, Icon, Spacing, Text } from 'zens-storybook'

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    padding: Spacing.XS,
  },
  content: {
    alignSelf: 'center',
    flex: 1,
  },
  unfold: {
    alignSelf: 'flex-start',
    flexDirection: 'row',
    alignItems: 'center',
  },
  label: {
    color: Color.metalGrey,
    marginHorizontal: Spacing.XS,
  },
  hovered: {
    color: Color.premiumBlack,
  },
  active: {
    color: Color.greyBlue,
  },
})

interface Props extends Omit<PressableProps, 'children'> {
  unfolded?: boolean
  loading?: boolean
  style?: StyleProp<ViewStyle>
}

const FilterUnfold = (props: PropsWithChildren<Props>) => {
  const { children, unfolded, loading, style, disabled, onFocus, onBlur, ...otherProps } = props

  const [active, setActive] = useState(false)

  const updateActive = (value: boolean) => (event: NativeSyntheticEvent<TargetedEvent>) => {
    setActive(value)
    value && onFocus && onFocus(event)
    !value && onBlur && onBlur(event)
  }
  useEffect(() => {
    if (disabled) setActive(false)
  }, [disabled])

  function renderContent(state: { pressed: boolean; hovered?: boolean }) {
    const { hovered } = state
    return (
      <View style={styles.container}>
        <View style={styles.content}>{children}</View>
        <View style={styles.unfold}>
          {loading && <ActivityIndicator color={Color.premiumBlack} />}
          <Text style={[styles.label, hovered && styles.hovered, active && styles.active]}>
            <Trans>Filters</Trans>
          </Text>
          <Icon
            name={unfolded ? 'up' : 'down'}
            size="XS"
            color={active ? Color.greyBlue : hovered ? Color.premiumBlack : Color.metalGrey}
          />
        </View>
      </View>
    )
  }

  return (
    <Pressable
      onFocus={updateActive(true)}
      onBlur={updateActive(false)}
      style={[
        Platform.select({
          // @ts-expect-error outline style none is not defined
          web: {
            outlineStyle: 'none',
          } as ViewStyle,
        }),
        style,
      ]}
      disabled={disabled}
      testID="FilterUnfold.Container"
      {...otherProps}
    >
      {renderContent}
    </Pressable>
  )
}

export default FilterUnfold
